<template>
	<b-modal
		ref="periods-by-padrillo-modal"
		size="xmd"
		hide-footer
		@hidden="handleCloseModal"
		scrollable
		no-close-on-backdrop
		no-close-on-esc
	>
		<template #modal-header>
			<div class="d-flex justify-content-between align-items-center w-100">
				<div class="font-weight-bold">Periodos de Postura | {{ padrillo.plate }} {{ padrillo.alias }}</div>
				<div style="display: flex; gap: 0.5rem">
					<b-button variant="danger" @click="handleCloseModal" v-b-tooltip.hover="'Cerrar'">
						<FeatherIcon icon="XIcon" />
					</b-button>
				</div>
			</div>
		</template>
		<b-overlay :show="isLoading">
			<b-table-simple responsive sticky-header="60vh" no-border-collapse>
				<b-thead class="sticky-header" style="white-space: nowrap">
					<b-tr>
						<b-th v-for="field in fields" :key="field.key" :class="field.class">
							{{ field.label }}
						</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<template v-if="periods.length > 0">
						<b-tr v-for="(period, index) in periods" :key="index">
							<b-td class="text-center">
								{{ period.period_start | myGlobalDayShort }}
							</b-td>
							<b-td class="text-center">
								<span v-if="period.period_end">
									{{ period.period_end | myGlobalDayShort }}
								</span>
								<span v-else>SIN FINALIZAR</span>
							</b-td>
							<b-td class="text-center">{{ period.days }}</b-td>
							<b-td class="text-center">
								<b-button variant="flat-info" @click="openInseminationsModal(period)">
									{{ period.insemination_count }}
								</b-button>
							</b-td>
							<b-td class="text-center">
								{{ Number(period.days) - Number(period.insemination_count) }}
							</b-td>
							<b-td class="text-center">
								<b-button variant="flat-info" @click="openPosturesModal(period)">
									{{ period.total_postures }}
								</b-button>
							</b-td>
						</b-tr>
					</template>
					<b-tr v-if="periods.length === 0">
						<b-td :colspan="fields.length" class="text-center">No hay registros para mostrar</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-overlay>
		<PosturesByPeriodModal v-if="showPosturesModal" :period="selectedPeriod" @close="showPosturesModal = false" />
		<InseminationsByPeriodModal
			v-if="showInseminationsModal"
			:period="selectedPeriod"
			@close="showInseminationsModal = false"
		/>
	</b-modal>
</template>

<script>
import PosturePeriodsService from "@/services/encaste/posturas/posture-periods.service.js"
import PosturesByPeriodModal from "@/components/specimens/posture-periods/PosturesByPeriodModal.vue"
import InseminationsByPeriodModal from "@/components/specimens/posture-periods/InseminationsByPeriodModal.vue"
export default {
	name: "PeriodsByPadrilloModal",
	props: {
		padrilloId: {
			required: true,
		},
	},
	components: {
		PosturesByPeriodModal,
		InseminationsByPeriodModal,
	},
	data: () => ({
		isLoading: false,
		fields: [
			{ key: "period_start", label: "Inicio", class: "text-center" },
			{ key: "period_end", label: "Fin", class: "text-center" },
			{ key: "days", label: "Días", class: "text-center" },
			{ key: "insemination_count", label: "Inseminaciones", class: "text-center" },
			{ key: "wo_insemination", label: "Sin Inseminar", class: "text-center" },
			{ key: "posturas", label: "Posturas", class: "text-center" },
		],
		periods: [],
		padrillo: null,
		showPosturesModal: false,
		showInseminationsModal: false,
	}),
	computed: {},
	methods: {
		openPosturesModal(period) {
			this.selectedPeriod = {
				id: period.id,
				period_start: period.period_start,
				period_end: period.period_end,
			}
			this.showPosturesModal = true
		},
		openInseminationsModal(period) {
			this.selectedPeriod = {
				id: period.id,
				period_start: period.period_start,
				period_end: period.period_end,
			}
			this.showInseminationsModal = true
		},
		handleCloseModal() {
			this.$emit("refresh")
			this.$emit("close")
		},
		async getRows() {
			try {
				this.isLoading = true
				const { data } = await PosturePeriodsService.getPeriodsByPadrillo(this.padrilloId)
				this.periods = data.periods || []
				this.padrillo = data.padrillo
			} catch (error) {
				console.error("Error fetching average weights report drafts:", error)
			} finally {
				this.isLoading = false
			}
		},
	},

	async mounted() {
		await this.getRows()
		this.$refs["periods-by-padrillo-modal"].toggle()
	},
}
</script>
